import { Component, ContentChildren, EventEmitter, Input, OnInit, Output, QueryList, TemplateRef } from '@angular/core';
import { PrimeTemplate } from 'primeng/api';
import { DateViewColumn } from 'src/app/core/models/date-view-column';

@Component({
  selector: 'laas-data-view',
  templateUrl: './data-view.component.html',
  styleUrls: ['./data-view.component.scss']
})
export class DataViewComponent implements OnInit {

  @Input() value: any[];
  @Input() paginator: boolean;
  @Input() rows: number;
  @Input() totalRecords: any;
  @Input() paginatorPosition: 'top' | 'bottom' | 'both' = 'both';
  @Input() showJumpToPageDropdown: boolean;
  @Input() showPageLinks: boolean;
  @Input() lazy: boolean;
  @Input() showHeader: boolean;
  @Input() showFooter: boolean;
  @Input() showDataViewLayoutOptions: boolean;
  @Output() onPage: EventEmitter<any>;
  @ContentChildren(PrimeTemplate) templates!: QueryList<PrimeTemplate>;
  @Input() defaultColumns: DateViewColumn[] = [];

  headerTemplate!: TemplateRef<any>;
  listItemTemplate!: TemplateRef<any>;
  gridItemTemplate!: TemplateRef<any>;
  footerTemplate!: TemplateRef<any>;

  constructor() {
    this.value = [];
    this.paginator = true;
    this.rows = 5;
    this.totalRecords = null;
    this.showJumpToPageDropdown = true;
    this.showPageLinks = false;
    this.lazy = false;
    this.showHeader = true;
    this.showFooter = true;
    this.showDataViewLayoutOptions = true;
    this.onPage = new EventEmitter();
  }

  ngOnInit(): void {
  }

  ngAfterContentInit(): void {
    this.templates.forEach((item) => {
      switch (item.getType()) {
        case 'header':
          this.headerTemplate = item.template;
          break;
        case 'listItem':
          this.listItemTemplate = item.template;
          break;
        case 'gridItem':
          this.gridItemTemplate = item.template;
          break;
        case 'footer':
          this.footerTemplate = item.template;
          break;
        default:
          break;
      }
    });
  }

  pageEvent(event: any): void {
    this.onPage.emit(event);
  }
}
